// contactValidation.js

export const validateContactForm = (formData) => {
  let errors = {};
  if (!formData.name.trim()) {
    errors.name = "Name is required";
  }
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Enter a valid email";
  }
  //   if (!formData.subject.trim()) {
  //     errors.subject = "Subject is required";
  //   }
  //   if (!formData.message.trim()) {
  //     errors.message = "Message is required";
  //   }
  return errors;
};

export const userLoginFormValidation = (formData) => {
  let errors = [];
  if (!formData.sol_roll_no.trim()) {
    errors.sol_roll_no = "SOL Roll Number/Mobile Number is required";
  }
  if (!formData.password) {
    errors.password = "Barcode/Control Number is required";
  }
  return errors;
};

export const adminLoginFormValidation = (formData) => {
  let errors = [];
  if (!formData.email.trim()) {
    errors.email = "Employee Code is required";
  }
  if (!formData.password) {
    errors.password = "Password is required";
  }
  return errors;
};
